/**
 * Whether the page is on its way out.
 *
 * A navigation (a checkout's redirect, a reload, a link) cancels the page's
 * fetches in flight, and every engine rejects them right after
 * `beforeunload` (measured 27 October 2026: Chromium "Failed to fetch",
 * Firefox "NetworkError when attempting to fetch resource.", WebKit "Load
 * failed"; `pagehide` comes later in Firefox and WebKit, so it cannot be the
 * signal). That is the page leaving, not a read that failed, and nothing to
 * report. A navigation that never happens (a `beforeunload` prompt kept the
 * page) stops counting after a while, and a page restored from the
 * back-forward cache is not leaving.
 */

const LEAVING_WINDOW_MS = 10_000;
let leavingAt = 0;

if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', () => { leavingAt = Date.now(); });
    window.addEventListener('pageshow', () => { leavingAt = 0; });
}

/** @param {number} [now] */
function isPageLeaving(now = Date.now()) {
    return leavingAt > 0 && now - leavingAt < LEAVING_WINDOW_MS;
}

export { isPageLeaving };
